import React from 'react';
import Select from 'react-select';
import './SelectsCity.scss';
import './SelectsCity-media.scss';
import { DeclOfNum } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import {content} from "../../services/content";

const SelectsCity = ({
  optionsFrom,
  optionsIn,
  valueFrom,
  valueIn,
  From,
  In,
  countsDays,
  funcSelectFrom,
  funcSelectIn,
}: Props) => {
  return (
    <div className="selects-city">
      <Select
        options={optionsFrom}
        placeholder={''}
        isSearchable={false}
        className="select-filter__item"
        classNamePrefix="select-filter"
        onChange={(selectedOpt: any) => funcSelectFrom(selectedOpt)}
        value={valueFrom}
      />
      <div className="selects-city__count">
        <div className="selects-city__arrow"></div>
        {countsDays.length !== 0 ? (
          <p className="body2">{`${countsDays[From][In]} ${DeclOfNum(countsDays[From][In], content.common.wordsDay)}`}</p>
        ) : null}
      </div>
      <Select
        options={optionsIn}
        placeholder={''}
        isSearchable={false}
        className="select-filter__item"
        classNamePrefix="select-filter"
        onChange={(selectedOpt: any) => funcSelectIn(selectedOpt)}
        value={valueIn}
      />
    </div>
  );
};

export default SelectsCity;
